import Navbar from "../components/Navbar";
import "./TextosLegales.css";

const AvisoLegal = () => {
  return (
  
        <div className="p-6 space-y-6 text-justify text-sm leading-relaxed max-w-3xl mx-auto">
          <h2 className="text-base font-bold">I. Objeto del Aviso Legal</h2>
          <p>
            Este Aviso Legal regula el acceso, navegación y uso de la aplicación
            móvil y/o web denominada{" "}
            <strong>“PASAPORTE HACIA EL EMPLEO”</strong>, desarrollada y
            gestionada por el Ayuntamiento de Isla Cristina, con domicilio en
            Avenida Gran Vía, 43, 21410 – Isla Cristina (Huelva).
          </p>
          <p>
            La mera utilización de la aplicación implica la aceptación plena y
            sin reservas del presente Aviso Legal por parte del usuario, que
            podrá ser modificado por el Ayuntamiento de Isla Cristina en
            cualquier momento. Las personas usuarias también quedarán sometidas
            a cualquier otra condición específica, aviso o instrucción que se
            establezca en relación con los servicios concretos prestados a
            través de la app.
          </p>

          <h2 className="text-base font-bold">
            II. Exclusión de Responsabilidad
          </h2>
          <p>
            El Ayuntamiento de Isla Cristina no garantiza la disponibilidad,
            continuidad ni la fiabilidad del funcionamiento de la aplicación,
            sus servicios o contenidos. Cuando sea técnicamente posible, se
            advertirá previamente de las interrupciones. El Ayuntamiento no se
            responsabiliza de los daños o perjuicios derivados de la falta de
            disponibilidad o del mal funcionamiento de la app o de cualquiera de
            sus funcionalidades.
          </p>

          <h2 className="text-base font-bold">III. Uso de la Aplicación</h2>
          <p>
            Queda prohibido el uso no autorizado de los contenidos, datos y
            recursos accesibles a través de la app. Salvo autorización previa,
            expresa y por escrito del Ayuntamiento de Isla Cristina, el usuario
            no podrá reproducir, distribuir, transformar, comunicar públicamente
            ni extraer, reutilizar o explotar, por cualquier medio, parte o la
            totalidad del contenido de esta aplicación más allá de los usos
            permitidos por la legislación vigente y por el uso personal del
            usuario.
          </p>

          <h2 className="text-base font-bold">
            IV. Propiedad Intelectual e Industrial
          </h2>
          <p>
            Todos los contenidos, incluyendo a título enunciativo, textos,
            imágenes, diseños, interfaces, logotipos, códigos fuente, marcas o
            signos distintivos, están protegidos por derechos de propiedad
            intelectual e industrial, y pertenecen al Ayuntamiento de Isla
            Cristina o a terceros que han autorizado su uso. El acceso a la app
            no implica cesión, renuncia ni transmisión de ningún derecho sobre
            dichos contenidos.
          </p>

          <h2 className="text-base font-bold">V. Protección de Datos</h2>
          <p>
            El uso de esta aplicación implica el tratamiento de datos personales
            en los términos establecidos por el{" "}
            <strong>Reglamento (UE) 2016/679</strong> del Parlamento Europeo y
            del Consejo (RGPD), y la <strong>Ley Orgánica 3/2018</strong>, de 5
            de diciembre, de Protección de Datos Personales y garantía de los
            derechos digitales (LOPDGDD).
          </p>
          <p>
            Los datos personales recabados a través de la aplicación serán
            tratados con la finalidad de{" "}
            <strong>
              gestionar la participación en el proyecto “PASAPORTE HACIA EL
              EMPLEO – Mejorando la empleabilidad de las personas”
            </strong>
            , y de facilitar el uso de los servicios y funcionalidades ofrecidos
            en esta plataforma digital, como parte de una intervención pública
            de interés social.
          </p>
          <p>
            Este proyecto está financiado con cargo a los{" "}
            <strong>
              Fondos Europeos procedentes del Mecanismo para la Recuperación y
              Resiliencia (MRR)
            </strong>
            , en virtud de la resolución favorable de 14 de julio de 2023, de la{" "}
            <strong>
              Dirección General de Protección Social y Barriadas de Actuación
              Preferente
            </strong>
            , relativa a la concesión de subvenciones destinadas a la
            transformación tecnológica e innovación en el ámbito de los
            servicios sociales, en régimen de concurrencia competitiva, conforme
            a las bases reguladoras publicadas en la{" "}
            <strong>Orden de 21 de diciembre de 2022</strong> (BOJA núm. 249 de
            30 de diciembre de 2022), por la que se concedió al{" "}
            <strong>Ayuntamiento de Isla Cristina</strong>, con N.I.F.
            P2104200G, el proyecto (Expediente SISS: (SSCC 633-2023-00000050-1).
          </p>
          <p>
            El responsable del tratamiento es el Ayuntamiento de Isla Cristina.
            Las personas interesadas podrán ejercer sus derechos de acceso,
            rectificación, supresión, oposición, limitación o portabilidad
            mediante solicitud dirigida al propio Ayuntamiento.
          </p>

          <h2 className="text-base font-bold">
            VI. Ley Aplicable y Jurisdicción
          </h2>
          <p>
            Este Aviso Legal se rige por la legislación española. Para cualquier
            controversia que pudiera derivarse del uso de la aplicación, las
            partes, con renuncia expresa a su fuero propio, se someten a los
            Juzgados y Tribunales de Huelva.
          </p>

          <h2 className="text-base font-bold">VII. Contenidos</h2>
          <p>
            Todos los contenidos disponibles a través de la aplicación,
            incluidos gráficos, vídeos, audios, documentos, informes,
            formularios, cuestionarios o materiales interactivos son propiedad
            del Ayuntamiento de Isla Cristina, o de terceros que han autorizado
            su uso, estando protegidos por la legislación nacional e
            internacional aplicable.
          </p>
        </div>
  );
};

export default AvisoLegal;
